module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/perfect/perfect-05-87d6a6a9bd33a764550fc08a016df29e.jpg";